import { PDFViewer, StyleSheet } from "@react-pdf/renderer";
import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { ModalHeaderBlack, MyModal } from "../features/RadConnStyle";

export default function PDFViewerTool(props) {
  const [winState, setWinState] = props.winState;
  const [objPdf, setObjPdf] = useState(null);

  useEffect(() => {
    if (winState.show) {
      console.log(winState?.docu);
      setObjPdf(
        <PDFViewer
          style={styles.container}
          children={winState.docu}
        ></PDFViewer>
      );
      console.log("Have data");
      return () => {
        console.log("No Data");
        setObjPdf(null);
      };
    }
  }, [winState?.show]);

  const handleClose = () => {
    setWinState((p) => ({ ...p, ...{ show: false } }));
  };
  return (
    <MyModal show={winState?.show} fullscreen backdrop>
      <ModalHeaderBlack closeButton onHide={handleClose}>
        ออกเอกสาร
      </ModalHeaderBlack>
      <ModalBody>
        {/* {winState?.docu ?? <PDFViewer children={winState.docu}></PDFViewer> ?? (
          <></>
        )} */}
        {/* <PDFViewer
          style={styles.container}
          children={winState.docu}
        ></PDFViewer> */}

        {objPdf}
      </ModalBody>
    </MyModal>
  );
}

const styles = StyleSheet.create({
  container: {
    border: "1px solid transparent",
    flex: 1,
    display: "flex",
    width: "100%",
    minHeight: "100vh",
    marginHorizontal: 0,
    marginVertical: 0,
    padding: 0,
  },
});
